// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB5OrydDOQTPNauTkFaFMmbw345YooPvMw",
  authDomain: "khukumoni-login.firebaseapp.com",
  projectId: "khukumoni-login",
  storageBucket: "khukumoni-login.firebasestorage.app",
  messagingSenderId: "271738458279",
  appId: "1:271738458279:web:4912c45e879236b6df4b82",

  // apiKey: process.env.REACT_APP_apiKey,
  // authDomain: process.env.REACT_APP_authDomain,
  // projectId: process.env.REACT_APP_projectId,
  // storageBucket: process.env.REACT_APP_storageBucket,
  // messagingSenderId: process.env.REACT_APP_messagingSenderId,
  // appId: process.env.REACT_APP_appId,
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
